import api from "./api";
import {
    SUPPORT_ACTIVE_LOGS,
    SUPPORT_ALL_LOGS,
    SUPPORT_LOGGERS,
    SUPPORT_LOGS
} from "../constants/urls.js";

export const support = {
    getAllLoggers: async () => {
        return (await api.get(SUPPORT_LOGGERS)).data;    },
    downloadActiveLogs: async () => {
        return (await api.get(SUPPORT_ACTIVE_LOGS, {responseType: 'arraybuffer'}));
    },
    downloadAllLogs: async () => {
        return (await api.get(SUPPORT_ALL_LOGS, {responseType: 'arraybuffer'}));
    },
    downloadLogsByDay: async (day) => {
      return (await api.get(`${SUPPORT_LOGS}/${day}`, {responseType: 'arraybuffer'}))
    },
    setLogLevel: async (name, level, logs) => {
        return (await api.put(`${SUPPORT_LOGGERS}/${name}/${level}`, logs)).data;
    }
};
